import VideoCard from "../../common/VideoCard";
import { useLocation } from "react-router-dom";
import { IoSearchOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import useSelectVideo from "../../../hooks/useSelectVideo";
import { useCallback, useEffect, useState } from "react";
import {
    AccountProfile,
    AccountProfilePosts,
    AccountProfilePostDelete
} from "../../../redux/ApiSlice/AccountProfileSlice";

export function PostsTab({ User_posts, User_profile, activeTab, postsTabScrollRef }) {
    const dispatch = useDispatch();
    const selectVideo = useSelectVideo();
    const location = useLocation();
    const ProfileDetails = useSelector((state) => state.AccountProfile);
    const { loadingMore, nextPage } = ProfileDetails;
    const [userPostData, setUserPostData] = useState(User_posts);
    const [search, setSearch] = useState("");

    const handleDeletePost = async (id) => {
        await dispatch(AccountProfilePostDelete(id));
        dispatch(AccountProfilePosts({ id: User_profile?.id }));
        dispatch(AccountProfile());
    };

    const handleSelectVideo = async (id) => {
        selectVideo(id, userPostData, location.pathname);
    };

    // Local search by post_description
    useEffect(() => {
        if (!search) {
            setUserPostData(User_posts);
        } else {
            const lower = search.toLowerCase();
            setUserPostData(
                (User_posts || []).filter(item =>
                    (item.post_description || "").toLowerCase().includes(lower)
                )
            );
        }
    }, [search, User_posts]);

    useEffect(() => {
        setUserPostData(User_posts);
    }, [User_posts]);

    const handleScroll = useCallback(() => {
        const container = postsTabScrollRef?.current;
        if (!container || !User_profile?.id || !nextPage || loadingMore || search || activeTab !== "posts") {
            return;
        }

        const hasReachedBottom =
            container.scrollTop + container.clientHeight >= container.scrollHeight - 10;

        if (hasReachedBottom) {
            dispatch(
                AccountProfilePosts({
                    id: User_profile?.id,
                    nextUrl: nextPage,
                    isLoadMore: true,
                })
            );
        }
    }, [dispatch, loadingMore, nextPage, User_profile?.id, search, activeTab, postsTabScrollRef]);

    useEffect(() => {
        const container = postsTabScrollRef?.current;
        if (!container) return;

        container.addEventListener("scroll", handleScroll);

        return () => {
            container.removeEventListener("scroll", handleScroll);
        };
    }, [handleScroll, postsTabScrollRef]);

    return (
        <div className="h-full w-full flex flex-col">
            <div className="relative flex-shrink-0 mx-2 mb-2">
                <IoSearchOutline className="absolute left-2 top-1/2 transform -translate-y-1/2 text-[18px] text-black" />
                <input
                    type="text"
                    value={search}
                    placeholder="Find Your Posts..."
                    onChange={e => setSearch(e.target.value)}
                    className="w-full text-[14px] pl-8 pr-2 py-1.5 rounded-lg bg-gray-100 outline-none focus:ring-2 focus:ring-[#BDE6FF]"
                />
            </div>

            {userPostData?.length > 0 ? (
                <>
                    <div
                        ref={postsTabScrollRef}
                        className={`grid grid-cols-3 gap-1 no-scrollbar px-2 pb-2 z-10 overflow-y-auto flex-1 ${activeTab === "posts" ? "" : "hidden"}`}
                        style={{ maxHeight: 'calc(34rem - 120px)' }}
                    >
                        {userPostData?.map((item) => (
                            <VideoCard
                                id={item.id}
                                belowDecs={true}
                                threeDots={true}
                                body={item.post_description}
                                views={item.views}
                                video={item.video_url}
                                view_count={item.view_count}
                                likes_count={item.likes_count}
                                authorId={item.created_by?.id}
                                selectVideo={handleSelectVideo}
                                handleDeletePost={handleDeletePost}
                                showDelete={true}
                                avatar_url={item.created_by.avatar_url}
                            />
                        ))}
                    </div>
                    {loadingMore && (
                        <div className="flex justify-center items-center">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#BDE6FF]"></div>
                        </div>
                    )}
                </>
            ) : (
                <div className="flex justify-center items-center h-[50%] w-full">
                    <p className="text-[10px] text-gray-400 dark:text-gray-200 mt-5">
                        {search ? 'No result found' : 'No Posts yet'}
                    </p>
                </div>
            )}
        </div>
    );
}
